function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.92874 3.99954V1.20954C7.92874 0.759542 7.38874 0.539542 7.07874 0.859542L3.27874 4.64954C3.07874 4.84954 3.07874 5.15954 3.27874 5.35954L7.06874 9.14954C7.38874 9.45954 7.92874 9.23954 7.92874 8.78954V5.99954C11.6587 5.99954 14.6087 9.41954 13.7887 13.2895C13.3187 15.5595 11.4787 17.3895 9.21874 17.8595C5.64874 18.6095 2.46874 16.1595 1.98874 12.8495C1.91874 12.3695 1.49874 11.9995 1.00874 11.9995C0.408739 11.9995 -0.0712611 12.5295 0.00873893 13.1295C0.628739 17.5195 4.80874 20.7695 9.53874 19.8495C12.6587 19.2395 15.1687 16.7295 15.7787 13.6095C16.7687 8.47954 12.8687 3.99954 7.92874 3.99954Z",
  fill: "#6D0FA7"
});

const SvgClear = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 21,
  viewBox: "0 0 16 21",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClear, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clear.5fbc8885.svg";
export { ForwardRef as ReactComponent };